/** `/count_status/` — poll a list count that the backend computes off-request.
 *
 * A grid whose `count_mode` is `async`/`deferred` gets `count: -1` plus an
 * `async_count_handle`; this resolves that handle. See
 * `backend/apiv2/lib/counting.py` for the protocol and
 * `components/DataGrid/useCountMode.ts` for the consumer.
 */
import { apiGet } from './client';

/** How a grid produces its total. Mirrors the backend `CountMode` enum. */
export type CountMode = 'sync' | 'async' | 'deferred';

/** `-1` on the wire means "not known", never a quantity. */
export const COUNT_UNKNOWN = -1;

export type CountState = 'ready' | 'pending' | 'stale' | 'failed';

export interface CountStatus {
  /** The total, or `COUNT_UNKNOWN` while it isn't known. */
  count: number;
  state: CountState;
}

/** Response of any `?count_only=1` list call. */
export interface CountOnlyResult {
  count: number;
  count_mode: CountMode;
  state: CountState;
  async_count_handle: string | null;
  count_is_capped?: boolean;
}

export function countStatus(handle: string): Promise<CountStatus> {
  return apiGet<CountStatus>(`/count_status/?handle=${encodeURIComponent(handle)}`);
}
